import { Trans } from '@lingui/react/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';

interface BSlugFeedbackNudgeProps {
  booking: BookingRecordDetailsCustomer;
}

export const BSlugFeedbackNudge = ({ booking }: BSlugFeedbackNudgeProps) => {
  return (
    <div className='flex flex-wrap items-center justify-between gap-4'>
      <div className='flex flex-col gap-0.5'>
        <p className='font-semibold text-primary'>
          <Trans>How was your experience?</Trans>
        </p>
        <p className='text-sm text-muted-foreground'>
          <Trans>Help us improve by sharing your thoughts</Trans>
        </p>
      </div>
      <NoddiLink
        endIcon='ArrowRight'
        className='w-full sm:w-fit'
        to={customerRoutes.feedbackForBooking.getPath({ slug: booking.slug })}
      >
        <Trans>Give feedback</Trans>
      </NoddiLink>
    </div>
  );
};
